@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-831_599_289)
internal val Res.drawable.S41: DrawableResource by lazy {
      DrawableResource("drawable:S41", setOf(
        ResourceItem(setOf(), "${MD}drawable/S41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(402_786_056)
internal val Res.drawable.S42: DrawableResource by lazy {
      DrawableResource("drawable:S42", setOf(
        ResourceItem(setOf(), "${MD}drawable/S42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_139_299_833)
internal val Res.drawable.S43: DrawableResource by lazy {
      DrawableResource("drawable:S43", setOf(
        ResourceItem(setOf(), "${MD}drawable/S43.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(396_220_235)
internal val Res.drawable.S44: DrawableResource by lazy {
      DrawableResource("drawable:S44", setOf(
        ResourceItem(setOf(), "${MD}drawable/S44.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-136_996_517)
internal val Res.drawable.S45: DrawableResource by lazy {
      DrawableResource("drawable:S45", setOf(
        ResourceItem(setOf(), "${MD}drawable/S45.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_065_055_024)
internal val Res.drawable.S46: DrawableResource by lazy {
      DrawableResource("drawable:S46", setOf(
        ResourceItem(setOf(), "${MD}drawable/S46.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(271_732_133)
internal val Res.drawable.S5: DrawableResource by lazy {
      DrawableResource("drawable:S5", setOf(
        ResourceItem(setOf(), "${MD}drawable/S5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_033_869_955)
internal val Res.drawable.S6: DrawableResource by lazy {
      DrawableResource("drawable:S6", setOf(
        ResourceItem(setOf(), "${MD}drawable/S6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_387_427_364)
internal val Res.drawable.S6A: DrawableResource by lazy {
      DrawableResource("drawable:S6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/S6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_642_696_851)
internal val Res.drawable.S7: DrawableResource by lazy {
      DrawableResource("drawable:S7", setOf(
        ResourceItem(setOf(), "${MD}drawable/S7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(156_868_734)
internal val Res.drawable.S8: DrawableResource by lazy {
      DrawableResource("drawable:S8", setOf(
        ResourceItem(setOf(), "${MD}drawable/S8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(293_485_045)
internal val Res.drawable.S9: DrawableResource by lazy {
      DrawableResource("drawable:S9", setOf(
        ResourceItem(setOf(), "${MD}drawable/S9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(613_070_480)
internal val Res.drawable.T1: DrawableResource by lazy {
      DrawableResource("drawable:T1", setOf(
        ResourceItem(setOf(), "${MD}drawable/T1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(742_092_478)
internal val Res.drawable.T10: DrawableResource by lazy {
      DrawableResource("drawable:T10", setOf(
        ResourceItem(setOf(), "${MD}drawable/T10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(187_850_764)
internal val Res.drawable.T11: DrawableResource by lazy {
      DrawableResource("drawable:T11", setOf(
        ResourceItem(setOf(), "${MD}drawable/T11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_458_578_207)
internal val Res.drawable.T11A: DrawableResource by lazy {
      DrawableResource("drawable:T11A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T11A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-690_294_614)
internal val Res.drawable.T12: DrawableResource by lazy {
      DrawableResource("drawable:T12", setOf(
        ResourceItem(setOf(), "${MD}drawable/T12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(301_585_178)
internal val Res.drawable.T13: DrawableResource by lazy {
      DrawableResource("drawable:T13", setOf(
        ResourceItem(setOf(), "${MD}drawable/T13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_258_896_215)
internal val Res.drawable.T14: DrawableResource by lazy {
      DrawableResource("drawable:T14", setOf(
        ResourceItem(setOf(), "${MD}drawable/T14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_229_838_355)
internal val Res.drawable.T15: DrawableResource by lazy {
      DrawableResource("drawable:T15", setOf(
        ResourceItem(setOf(), "${MD}drawable/T15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(392_687_760)
internal val Res.drawable.T16: DrawableResource by lazy {
      DrawableResource("drawable:T16", setOf(
        ResourceItem(setOf(), "${MD}drawable/T16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(373_769_633)
internal val Res.drawable.T16A: DrawableResource by lazy {
      DrawableResource("drawable:T16A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T16A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-129_466_096)
internal val Res.drawable.T17: DrawableResource by lazy {
      DrawableResource("drawable:T17", setOf(
        ResourceItem(setOf(), "${MD}drawable/T17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_577_460_872)
internal val Res.drawable.T18: DrawableResource by lazy {
      DrawableResource("drawable:T18", setOf(
        ResourceItem(setOf(), "${MD}drawable/T18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_433_587_017)
internal val Res.drawable.T19: DrawableResource by lazy {
      DrawableResource("drawable:T19", setOf(
        ResourceItem(setOf(), "${MD}drawable/T19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-422_045_467)
internal val Res.drawable.T2: DrawableResource by lazy {
      DrawableResource("drawable:T2", setOf(
        ResourceItem(setOf(), "${MD}drawable/T2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_930_665_334)
internal val Res.drawable.T20: DrawableResource by lazy {
      DrawableResource("drawable:T20", setOf(
        ResourceItem(setOf(), "${MD}drawable/T20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(488_231_362)
internal val Res.drawable.T21: DrawableResource by lazy {
      DrawableResource("drawable:T21", setOf(
        ResourceItem(setOf(), "${MD}drawable/T21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-902_603_715)
internal val Res.drawable.T22: DrawableResource by lazy {
      DrawableResource("drawable:T22", setOf(
        ResourceItem(setOf(), "${MD}drawable/T22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(440_511_680)
internal val Res.drawable.T23: DrawableResource by lazy {
      DrawableResource("drawable:T23", setOf(
        ResourceItem(setOf(), "${MD}drawable/T23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_010_814_468)
internal val Res.drawable.T24: DrawableResource by lazy {
      DrawableResource("drawable:T24", setOf(
        ResourceItem(setOf(), "${MD}drawable/T24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_333_787_121)
internal val Res.drawable.T25: DrawableResource by lazy {
      DrawableResource("drawable:T25", setOf(
        ResourceItem(setOf(), "${MD}drawable/T25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_323_280_575)
internal val Res.drawable.T26: DrawableResource by lazy {
      DrawableResource("drawable:T26", setOf(
        ResourceItem(setOf(), "${MD}drawable/T26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(554_240_667)
internal val Res.drawable.T27: DrawableResource by lazy {
      DrawableResource("drawable:T27", setOf(
        ResourceItem(setOf(), "${MD}drawable/T27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(819_182_550)
internal val Res.drawable.T28: DrawableResource by lazy {
      DrawableResource("drawable:T28", setOf(
        ResourceItem(setOf(), "${MD}drawable/T28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-980_177_784)
internal val Res.drawable.T29: DrawableResource by lazy {
      DrawableResource("drawable:T29", setOf(
        ResourceItem(setOf(), "${MD}drawable/T29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(848_376_685)
internal val Res.drawable.T3: DrawableResource by lazy {
      DrawableResource("drawable:T3", setOf(
        ResourceItem(setOf(), "${MD}drawable/T3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(994_937_626)
internal val Res.drawable.T30: DrawableResource by lazy {
      DrawableResource("drawable:T30", setOf(
        ResourceItem(setOf(), "${MD}drawable/T30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_187_891_692)
internal val Res.drawable.T31: DrawableResource by lazy {
      DrawableResource("drawable:T31", setOf(
        ResourceItem(setOf(), "${MD}drawable/T31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(158_872_547)
internal val Res.drawable.T32: DrawableResource by lazy {
      DrawableResource("drawable:T32", setOf(
        ResourceItem(setOf(), "${MD}drawable/T32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-805_197_140)
internal val Res.drawable.T32A: DrawableResource by lazy {
      DrawableResource("drawable:T32A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T32A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_339_016_778)
internal val Res.drawable.T33: DrawableResource by lazy {
      DrawableResource("drawable:T33", setOf(
        ResourceItem(setOf(), "${MD}drawable/T33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_325_546_263)
internal val Res.drawable.T33A: DrawableResource by lazy {
      DrawableResource("drawable:T33A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T33A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_822_725_944)
internal val Res.drawable.T34: DrawableResource by lazy {
      DrawableResource("drawable:T34", setOf(
        ResourceItem(setOf(), "${MD}drawable/T34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(306_761_805)
internal val Res.drawable.T35: DrawableResource by lazy {
      DrawableResource("drawable:T35", setOf(
        ResourceItem(setOf(), "${MD}drawable/T35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_079_743_252)
internal val Res.drawable.T36: DrawableResource by lazy {
      DrawableResource("drawable:T36", setOf(
        ResourceItem(setOf(), "${MD}drawable/T36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_928_681_025)
internal val Res.drawable.T3A: DrawableResource by lazy {
      DrawableResource("drawable:T3A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T3A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(819_719_620)
internal val Res.drawable.T4: DrawableResource by lazy {
      DrawableResource("drawable:T4", setOf(
        ResourceItem(setOf(), "${MD}drawable/T4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(956_266_657)
internal val Res.drawable.T5: DrawableResource by lazy {
      DrawableResource("drawable:T5", setOf(
        ResourceItem(setOf(), "${MD}drawable/T5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-243_693_995)
internal val Res.drawable.T6: DrawableResource by lazy {
      DrawableResource("drawable:T6", setOf(
        ResourceItem(setOf(), "${MD}drawable/T6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-277_096_352)
internal val Res.drawable.T7: DrawableResource by lazy {
      DrawableResource("drawable:T7", setOf(
        ResourceItem(setOf(), "${MD}drawable/T7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(482_900_249)
internal val Res.drawable.T7A: DrawableResource by lazy {
      DrawableResource("drawable:T7A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T7A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(613_734_021)
internal val Res.drawable.T8: DrawableResource by lazy {
      DrawableResource("drawable:T8", setOf(
        ResourceItem(setOf(), "${MD}drawable/T8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_959_417_305)
internal val Res.drawable.T8A: DrawableResource by lazy {
      DrawableResource("drawable:T8A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T8A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_869_437_345)
internal val Res.drawable.T9: DrawableResource by lazy {
      DrawableResource("drawable:T9", setOf(
        ResourceItem(setOf(), "${MD}drawable/T9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-101_304_497)
internal val Res.drawable.T9A: DrawableResource by lazy {
      DrawableResource("drawable:T9A", setOf(
        ResourceItem(setOf(), "${MD}drawable/T9A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_508_266_537)
internal val Res.drawable.U1: DrawableResource by lazy {
      DrawableResource("drawable:U1", setOf(
        ResourceItem(setOf(), "${MD}drawable/U1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_718_844_038)
internal val Res.drawable.U10: DrawableResource by lazy {
      DrawableResource("drawable:U10", setOf(
        ResourceItem(setOf(), "${MD}drawable/U10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(810_372_902)
internal val Res.drawable.U11: DrawableResource by lazy {
      DrawableResource("drawable:U11", setOf(
        ResourceItem(setOf(), "${MD}drawable/U11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-589_515_626)
internal val Res.drawable.U12: DrawableResource by lazy {
      DrawableResource("drawable:U12", setOf(
        ResourceItem(setOf(), "${MD}drawable/U12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_112_197_049)
internal val Res.drawable.U13: DrawableResource by lazy {
      DrawableResource("drawable:U13", setOf(
        ResourceItem(setOf(), "${MD}drawable/U13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-830_554_541)
internal val Res.drawable.U14: DrawableResource by lazy {
      DrawableResource("drawable:U14", setOf(
        ResourceItem(setOf(), "${MD}drawable/U14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-144_473_270)
internal val Res.drawable.U15: DrawableResource by lazy {
      DrawableResource("drawable:U15", setOf(
        ResourceItem(setOf(), "${MD}drawable/U15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-982_441_349)
internal val Res.drawable.U16: DrawableResource by lazy {
      DrawableResource("drawable:U16", setOf(
        ResourceItem(setOf(), "${MD}drawable/U16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(497_435_572)
internal val Res.drawable.U17: DrawableResource by lazy {
      DrawableResource("drawable:U17", setOf(
        ResourceItem(setOf(), "${MD}drawable/U17.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_450_957_844)
internal val Res.drawable.U18: DrawableResource by lazy {
      DrawableResource("drawable:U18", setOf(
        ResourceItem(setOf(), "${MD}drawable/U18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(643_576_845)
internal val Res.drawable.U19: DrawableResource by lazy {
      DrawableResource("drawable:U19", setOf(
        ResourceItem(setOf(), "${MD}drawable/U19.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_951_190_369)
internal val Res.drawable.U2: DrawableResource by lazy {
      DrawableResource("drawable:U2", setOf(
        ResourceItem(setOf(), "${MD}drawable/U2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_071_647_871)
internal val Res.drawable.U20: DrawableResource by lazy {
      DrawableResource("drawable:U20", setOf(
        ResourceItem(setOf(), "${MD}drawable/U20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_592_061_677)
internal val Res.drawable.U21: DrawableResource by lazy {
      DrawableResource("drawable:U21", setOf(
        ResourceItem(setOf(), "${MD}drawable/U21.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_191_488_184)
internal val Res.drawable.U22: DrawableResource by lazy {
      DrawableResource("drawable:U22", setOf(
        ResourceItem(setOf(), "${MD}drawable/U22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(596_681_206)
internal val Res.drawable.U23: DrawableResource by lazy {
      DrawableResource("drawable:U23", setOf(
        ResourceItem(setOf(), "${MD}drawable/U23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_995_879_092)
internal val Res.drawable.U23A: DrawableResource by lazy {
      DrawableResource("drawable:U23A", setOf(
        ResourceItem(setOf(), "${MD}drawable/U23A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_788_383_014)
internal val Res.drawable.U24: DrawableResource by lazy {
      DrawableResource("drawable:U24", setOf(
        ResourceItem(setOf(), "${MD}drawable/U24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_118_220_615)
internal val Res.drawable.U25: DrawableResource by lazy {
      DrawableResource("drawable:U25", setOf(
        ResourceItem(setOf(), "${MD}drawable/U25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_459_632_065)
internal val Res.drawable.U26: DrawableResource by lazy {
      DrawableResource("drawable:U26", setOf(
        ResourceItem(setOf(), "${MD}drawable/U26.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(139_741_736)
internal val Res.drawable.U27: DrawableResource by lazy {
      DrawableResource("drawable:U27", setOf(
        ResourceItem(setOf(), "${MD}drawable/U27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(995_424_007)
internal val Res.drawable.U28: DrawableResource by lazy {
      DrawableResource("drawable:U28", setOf(
        ResourceItem(setOf(), "${MD}drawable/U28.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_109_466_899)
internal val Res.drawable.U29: DrawableResource by lazy {
      DrawableResource("drawable:U29", setOf(
        ResourceItem(setOf(), "${MD}drawable/U29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_919_468_272)
internal val Res.drawable.U29A: DrawableResource by lazy {
      DrawableResource("drawable:U29A", setOf(
        ResourceItem(setOf(), "${MD}drawable/U29A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_680_047_141)
internal val Res.drawable.U3: DrawableResource by lazy {
      DrawableResource("drawable:U3", setOf(
        ResourceItem(setOf(), "${MD}drawable/U3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_320_398_438)
internal val Res.drawable.U30: DrawableResource by lazy {
      DrawableResource("drawable:U30", setOf(
        ResourceItem(setOf(), "${MD}drawable/U30.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_233_855_463)
internal val Res.drawable.U31: DrawableResource by lazy {
      DrawableResource("drawable:U31", setOf(
        ResourceItem(setOf(), "${MD}drawable/U31.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-797_878_250)
internal val Res.drawable.U32: DrawableResource by lazy {
      DrawableResource("drawable:U32", setOf(
        ResourceItem(setOf(), "${MD}drawable/U32.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-207_792_337)
internal val Res.drawable.U32A: DrawableResource by lazy {
      DrawableResource("drawable:U32A", setOf(
        ResourceItem(setOf(), "${MD}drawable/U32A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_639_337_378)
internal val Res.drawable.U33: DrawableResource by lazy {
      DrawableResource("drawable:U33", setOf(
        ResourceItem(setOf(), "${MD}drawable/U33.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_979_784_628)
internal val Res.drawable.U34: DrawableResource by lazy {
      DrawableResource("drawable:U34", setOf(
        ResourceItem(setOf(), "${MD}drawable/U34.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_031_165_864)
internal val Res.drawable.U35: DrawableResource by lazy {
      DrawableResource("drawable:U35", setOf(
        ResourceItem(setOf(), "${MD}drawable/U35.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_856_675_961)
internal val Res.drawable.U36: DrawableResource by lazy {
      DrawableResource("drawable:U36", setOf(
        ResourceItem(setOf(), "${MD}drawable/U36.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_776_325_463)
internal val Res.drawable.U37: DrawableResource by lazy {
      DrawableResource("drawable:U37", setOf(
        ResourceItem(setOf(), "${MD}drawable/U37.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(855_354_241)
internal val Res.drawable.U38: DrawableResource by lazy {
      DrawableResource("drawable:U38", setOf(
        ResourceItem(setOf(), "${MD}drawable/U38.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-437_849_397)
internal val Res.drawable.U39: DrawableResource by lazy {
      DrawableResource("drawable:U39", setOf(
        ResourceItem(setOf(), "${MD}drawable/U39.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-623_874_107)
internal val Res.drawable.U4: DrawableResource by lazy {
      DrawableResource("drawable:U4", setOf(
        ResourceItem(setOf(), "${MD}drawable/U4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(501_087_789)
internal val Res.drawable.U40: DrawableResource by lazy {
      DrawableResource("drawable:U40", setOf(
        ResourceItem(setOf(), "${MD}drawable/U40.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-774_281_433)
internal val Res.drawable.U41: DrawableResource by lazy {
      DrawableResource("drawable:U41", setOf(
        ResourceItem(setOf(), "${MD}drawable/U41.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-994_207_944)
internal val Res.drawable.U42: DrawableResource by lazy {
      DrawableResource("drawable:U42", setOf(
        ResourceItem(setOf(), "${MD}drawable/U42.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(412_197_263)
internal val Res.drawable.U5: DrawableResource by lazy {
      DrawableResource("drawable:U5", setOf(
        ResourceItem(setOf(), "${MD}drawable/U5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(581_859_366)
internal val Res.drawable.U6: DrawableResource by lazy {
      DrawableResource("drawable:U6", setOf(
        ResourceItem(setOf(), "${MD}drawable/U6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_733_576_799)
internal val Res.drawable.U6A: DrawableResource by lazy {
      DrawableResource("drawable:U6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/U6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_094_492_902)
internal val Res.drawable.U6B: DrawableResource by lazy {
      DrawableResource("drawable:U6B", setOf(
        ResourceItem(setOf(), "${MD}drawable/U6B.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable8Resources(map: MutableMap<String, DrawableResource>) {
  map.put("S41", Res.drawable.S41)
  map.put("S42", Res.drawable.S42)
  map.put("S43", Res.drawable.S43)
  map.put("S44", Res.drawable.S44)
  map.put("S45", Res.drawable.S45)
  map.put("S46", Res.drawable.S46)
  map.put("S5", Res.drawable.S5)
  map.put("S6", Res.drawable.S6)
  map.put("S6A", Res.drawable.S6A)
  map.put("S7", Res.drawable.S7)
  map.put("S8", Res.drawable.S8)
  map.put("S9", Res.drawable.S9)
  map.put("T1", Res.drawable.T1)
  map.put("T10", Res.drawable.T10)
  map.put("T11", Res.drawable.T11)
  map.put("T11A", Res.drawable.T11A)
  map.put("T12", Res.drawable.T12)
  map.put("T13", Res.drawable.T13)
  map.put("T14", Res.drawable.T14)
  map.put("T15", Res.drawable.T15)
  map.put("T16", Res.drawable.T16)
  map.put("T16A", Res.drawable.T16A)
  map.put("T17", Res.drawable.T17)
  map.put("T18", Res.drawable.T18)
  map.put("T19", Res.drawable.T19)
  map.put("T2", Res.drawable.T2)
  map.put("T20", Res.drawable.T20)
  map.put("T21", Res.drawable.T21)
  map.put("T22", Res.drawable.T22)
  map.put("T23", Res.drawable.T23)
  map.put("T24", Res.drawable.T24)
  map.put("T25", Res.drawable.T25)
  map.put("T26", Res.drawable.T26)
  map.put("T27", Res.drawable.T27)
  map.put("T28", Res.drawable.T28)
  map.put("T29", Res.drawable.T29)
  map.put("T3", Res.drawable.T3)
  map.put("T30", Res.drawable.T30)
  map.put("T31", Res.drawable.T31)
  map.put("T32", Res.drawable.T32)
  map.put("T32A", Res.drawable.T32A)
  map.put("T33", Res.drawable.T33)
  map.put("T33A", Res.drawable.T33A)
  map.put("T34", Res.drawable.T34)
  map.put("T35", Res.drawable.T35)
  map.put("T36", Res.drawable.T36)
  map.put("T3A", Res.drawable.T3A)
  map.put("T4", Res.drawable.T4)
  map.put("T5", Res.drawable.T5)
  map.put("T6", Res.drawable.T6)
  map.put("T7", Res.drawable.T7)
  map.put("T7A", Res.drawable.T7A)
  map.put("T8", Res.drawable.T8)
  map.put("T8A", Res.drawable.T8A)
  map.put("T9", Res.drawable.T9)
  map.put("T9A", Res.drawable.T9A)
  map.put("U1", Res.drawable.U1)
  map.put("U10", Res.drawable.U10)
  map.put("U11", Res.drawable.U11)
  map.put("U12", Res.drawable.U12)
  map.put("U13", Res.drawable.U13)
  map.put("U14", Res.drawable.U14)
  map.put("U15", Res.drawable.U15)
  map.put("U16", Res.drawable.U16)
  map.put("U17", Res.drawable.U17)
  map.put("U18", Res.drawable.U18)
  map.put("U19", Res.drawable.U19)
  map.put("U2", Res.drawable.U2)
  map.put("U20", Res.drawable.U20)
  map.put("U21", Res.drawable.U21)
  map.put("U22", Res.drawable.U22)
  map.put("U23", Res.drawable.U23)
  map.put("U23A", Res.drawable.U23A)
  map.put("U24", Res.drawable.U24)
  map.put("U25", Res.drawable.U25)
  map.put("U26", Res.drawable.U26)
  map.put("U27", Res.drawable.U27)
  map.put("U28", Res.drawable.U28)
  map.put("U29", Res.drawable.U29)
  map.put("U29A", Res.drawable.U29A)
  map.put("U3", Res.drawable.U3)
  map.put("U30", Res.drawable.U30)
  map.put("U31", Res.drawable.U31)
  map.put("U32", Res.drawable.U32)
  map.put("U32A", Res.drawable.U32A)
  map.put("U33", Res.drawable.U33)
  map.put("U34", Res.drawable.U34)
  map.put("U35", Res.drawable.U35)
  map.put("U36", Res.drawable.U36)
  map.put("U37", Res.drawable.U37)
  map.put("U38", Res.drawable.U38)
  map.put("U39", Res.drawable.U39)
  map.put("U4", Res.drawable.U4)
  map.put("U40", Res.drawable.U40)
  map.put("U41", Res.drawable.U41)
  map.put("U42", Res.drawable.U42)
  map.put("U5", Res.drawable.U5)
  map.put("U6", Res.drawable.U6)
  map.put("U6A", Res.drawable.U6A)
  map.put("U6B", Res.drawable.U6B)
}
